<script>  
  import Saos from 'saos/src/Saos.svelte';
</script>

<div class="ecosystem_section" id="Governance">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-12 order-lg-2 text-center mb-lg-0 mb-4">
          <img src="/img/images/laptop-dark.png" alt="laptop" class="img-fluid"/>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="common_home_section pe-lg-3">
            <h2>Governance</h2>
            <p>Community is the heart of who we are.  Our goal is to create an ecosystem that empowers DOE Token holders through decentralized governance. 
              With a DAO established, we seek to engage the community's participation in key decision making for the project. The DAO provides the opportunity for 
              complete decentralization of the project, through multiple phases to ensure safety and security of the tokenomics. 
            </p>
            <div class="btn_group">
              <a href="https://medium.com/dogs-of-elon-community/introducing-dogs-of-elon-governance-dao-5d366f55e23e" class="fill_btn" target="_blank">Learn More</a>                 
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>